import { setActive } from './states';

export const services = {
  setActive,
};
